"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _chips = require("../../chips");
var _underscore = _interopRequireDefault(require("underscore"));
var _translations_context = _interopRequireDefault(require("../../../translations/translations_context"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SelectedChips = function SelectedChips(_ref) {
  var condensedUnitName = _ref.condensedUnitName,
    flyoutIsOpen = _ref.flyoutIsOpen,
    selectedItems = _ref.selectedItems,
    removeSelectedItem = _ref.removeSelectedItem,
    reset = _ref.reset,
    getSelectedItemProps = _ref.getSelectedItemProps;
  var translations = React.useContext(_translations_context["default"]);
  if (_underscore["default"].isEmpty(selectedItems)) {
    return null;
  }
  if (!flyoutIsOpen && condensedUnitName) {
    return /*#__PURE__*/React.createElement("span", {
      key: "selected-condensed-item"
    }, /*#__PURE__*/React.createElement(_chips.Chip, {
      "data-provides": "selected-condensed-item",
      text: translations.birch.dropdowns.condensed_chip_text(condensedUnitName, selectedItems.length),
      onRemove: function onRemove(e) {
        e.stopPropagation();
        reset();
      }
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, selectedItems.map(function (selectedItem, index) {
    return /*#__PURE__*/React.createElement("span", (0, _extends2["default"])({
      key: "selected-item-".concat(index)
    }, getSelectedItemProps({
      selectedItem: selectedItem.value,
      index: index
    })), /*#__PURE__*/React.createElement(_chips.Chip, {
      "data-provides": "selected-item-".concat(selectedItem.value),
      text: selectedItem.label,
      onRemove: function onRemove(e) {
        e.stopPropagation();
        removeSelectedItem(selectedItem);
      }
    }));
  }));
};
var _default = SelectedChips;
exports["default"] = _default;